import { Translation } from "..";

const it: Translation = {
  common: {
    save: "Salva",
    cancel: "Annulla",
    edit: "Modifica",
    delete: "Elimina",
    remove: "Rimuovi",
    submit: "Invia",
    back: "Indietro",
    loading: "Caricamento...",
    search: "Cerca",
    yes: "Sì",
    no: "No",
    close: "Chiudi",
    confirm: "Conferma",
    actions: "Azioni",
    noData: "Nessun dato disponibile",
    error: "Si è verificato un errore",
    success: "Successo",
    required: "Questo campo è obbligatorio",
    invalidUrl: "Inserisci un URL valido",
    nonNegativeNumber: "Inserisci un numero intero maggiore o uguale a 0",
    optional: "Opzionale",
    notSet: "Non settato",
    descriptionHint:
      "Si prega di essere il più dettagliato ed esaustivo possibile. Includere il contesto, gli obiettivi, il comportamento atteso e qualsiasi vincolo rilevante.",
  },
  nav: {
    dashboard: "Dashboard",
    newRequest: "Nuova Richiesta",
    requests: "Richieste",
    inventory: "Inventario",
    newInventory: "Nuovo Elemento Inventario",
    users: "Utenti",
    profile: "Profilo",
    admin: "Admin",
    language: "Lingua",
    help: "Aiuto",
    manual: "Manuale Utente",
    logout: "Esci",
  },
  requests: {
    title: "Titolo",
    description: "Descrizione",
    audience: "Pubblico",
    audienceInternal: "Interno",
    audienceInternalInfo:
      "Scegli questa opzione se l'applicazione è destinata esclusivamente ai dipendenti Rotoblaas. Non sarà accessibile dall'esterno dell'azienda.",
    audienceExternal: "Esterno",
    audienceExternalInfo:
      "Scegli questa opzione se l'applicazione sarà accessibile anche da persone esterne a Rotoblaas — ad esempio tramite il sito web, EService o altri strumenti pubblici.",
    departments: "Reparti",
    needsErpIntegration: "Richiede Integrazione ERP",
    needsErpIntegrationInfo:
      "Seleziona questa opzione se l'applicativo dovrà scambiare dati o integrarsi con altri sistemi aziendali del gruppo. Esempi: Semiramis, Pimcore, EService, CRM.",
    participants: "Partecipanti",
    participantsInfo: "Aggiungi partecipanti a cui vuoi che venga notificata la creazione di questa richiesta.",
    status: "Stato",
    statusDraft: "Bozza",
    statusNew: "Aperto",
    statusInProgress: "In Corso",
    statusCompleted: "Completato",
    responsibleDepartment: "Reparto Responsabile",
    responsibleDepartmentIntegrations: "Integrazioni",
    responsibleDepartmentSoftwareDevelopment: "Sviluppo Software",
    responsibleDepartmentIct: "ICT",
    estimateDays: "Stima (Giorni)",
    internalNotes: "Note Interne",
    approvedBy: "Approvato Da",
    approvedAt: "Approvato Il",
    createdBy: "Creato Da",
    createdAt: "Creato Il",
    supervisor: "Supervisore",
    approve: "Approva",
    newRequest: "Nuova Richiesta",
    viewRequestPageTitle: "Richiesta #{{id}}: {{title}}",
    editRequestPageTitle: "Modifica: {{title}}",
    allRequests: "Tutte le Richieste",
    backToRequests: "Torna alle Richieste",
    backToRequest: "Torna alla Richiesta",
    filterAll: "Tutte",
    filterDraft: "Bozza",
    filterNew: "Nuove",
    filterInProgress: "In Corso",
    filterCompleted: "Completate",
    approveSuccess: "Richiesta approvata con successo",
    submitSuccess: "Richiesta inviata con successo",
    updateSuccess: "Richiesta aggiornata con successo",
    managementSection: "Azioni di Gestione",
    auditTrail: "Registro Attività",
    deleteRequest: "Elimina Richiesta",
    confirmDeleteRequest: "Sei sicuro di voler eliminare questa richiesta? L'operazione non è reversibile.",
    deleteSuccess: "Richiesta eliminata con successo",
    noRequests: "Nessuna richiesta trovata",
    typeLabel: "Richiesta di funzionalità",
  },
  inventory: {
    name: "Nome",
    description: "Descrizione",
    improvementNotes: "Note di Miglioramento",
    improvementNotesInfo:
      "Inserisci eventuali punti di miglioramento, integrazioni con ERP, qualsiasi cosa non sei riuscito a gestire in autonomia.",
    githubUrl: "URL GitHub",
    deploymentLocation: "Posizione Deployment",
    deploymentLocationInfo: "Dov'è salvato/installato il progetto? Es. SharePoint, server locale…",
    audience: "Pubblico",
    audienceInternal: "Interno",
    audienceExternal: "Esterno",
    participants: "Partecipanti",
    status: "Stato",
    statusUnderReview: "In Valutazione",
    statusTakenOver: "Preso in carico",
    statusRejected: "Rifiutato",
    statusCompleted: "Completato",
    rejectCause: "Causa Rifiuto",
    rejectCauseNotInteresting: "Non interessante",
    rejectCauseDuplicate: "Duplicato",
    rejectCauseNonCompliant: "Non conforme",
    rejectCauseOutOfScope: "Fuori ambito",
    rejectCauseInsufficientInfo: "Informazioni insufficienti",
    rejectCauseNotSustainable: "Non sostenibile",
    rejectCauseOther: "Altro",
    rejectNote: "Nota Rifiuto",
    attachments: "Allegati",
    uploadAttachment: "Carica Allegato",
    addAttachment: "Aggiungi Allegato",
    noAttachments: "Nessun allegato",
    attachmentUploadFailed: "Impossibile caricare uno o più allegati. L'elemento non è stato salvato, riprova.",
    createdBy: "Creato Da",
    createdAt: "Creato Il",
    newItem: "Nuovo Elemento Inventario",
    allItems: "Tutti gli Elementi",
    viewInventoryPageTitle: "Elemento #{{id}}: {{title}}",
    editInventoryPageTitle: "Modifica Elemento #{{id}}: {{title}}",
    backToInventory: "Torna all'Inventario",
    backToInventories: "Torna agli Inventari",
    audienceExternalAlert:
      "Gli elementi destinati a un pubblico esterno devono rispettare i vincoli HTML e JS. Assicurarsi che il codice rispetti gli standard web.",
    submitSuccess: "Elemento inventario inviato con successo",
    updateSuccess: "Elemento inventario aggiornato con successo",
    managementSection: "Gestione",
    noItems: "Nessun elemento inventario trovato",
    filterAll: "Tutti",
    filterUnderReview: "In Valutazione",
    filterTakenOver: "Preso in carico",
    filterRejected: "Rifiutato",
    filterCompleted: "Completato",
    fileSize: "Dimensione",
    uploadedBy: "Caricato da",
    uploadedAt: "Caricato il",
    deleteAttachment: "Elimina Allegato",
    confirmDeleteAttachment: "Sei sicuro di voler eliminare questo allegato?",
  },
  notifications: {
    title: "Notifiche",
    markAllRead: "Segna tutto come letto",
    markAsRead: "Segna come letto",
    noNotifications: "Nessuna notifica",
    unread: "non lette",
    seeAll: "Vedi tutte le notifiche",
    filterAll: "Tutte",
    filterUnread: "Non lette",
    actions: {
      new_inventory_item: "ha censito un nuovo elemento all'inventario",
      request_approved: "ha approvato una richiesta di sviluppo",
    },
  },
  profile: {
    language: "Lingua",
    manager: "Manager",
    noManager: "Nessun manager assegnato",
    english: "English (UK)",
    usEnglish: "English (US)",
    italian: "Italiano",
    french: "Français",
    german: "Deutsch",
    spanish: "Español",
    saveLanguage: "Salva Lingua",
    languageSaved: "Lingua salvata",
    title: "Profilo Utente & Impostazioni",
    personalInfo: "Informazioni Personali",
    languageSettings: "Impostazioni Lingua",
  },
  dashboard: {
    welcome: "Benvenuto",
    allRequests: "Tutte le Richieste",
    allInventory: "Tutti gli Elementi",
    myRequests: "Le Mie Richieste",
    myInventory: "I Miei Elementi",
    recentNotifications: "Notifiche Recenti",
    createRequest: "Crea Richiesta",
    createInventory: "Aggiungi Elemento",
    statusNew: "Nuovo",
    statusInProgress: "In Corso",
    statusCompleted: "Completato",
    statusToApprove: "Da Approvare",
    total: "Totale",
  },
  users: {
    allUsers: "Tutti gli utenti",
    addUser: "Aggiungi utente",
    name: "Nome",
    firstName: "Nome",
    lastName: "Cognome",
    email: "Email",
    department: "Reparto",
    isAdmin: "Admin",
    lastAccess: "Ultimo Accesso",
    noUsers: "Nessun utente trovato",
    addUserSuccess: "Utente aggiunto con successo",
    userNotFound: "Utente non trovato",
    confirmDelete: "Sei sicuro di voler eliminare questo utente?",
    roleAll: "Tutti",
    roleAdmin: "Admin",
    roleNonAdmin: "Non-Admin",
    withAccess: "Con Accesso",
    withoutAccess: "Senza Accesso",
  },
  admin: {
    title: "Admin",
    users: "Utenti",
    noAdminEndpoint: "Nota: la gestione dei ruoli utente non è ancora disponibile tramite API.",
    email: "Email",
    name: "Nome",
    isAdmin: "Admin",
    managerId: "ID Manager",
    createdAt: "Creato Il",
  },
};

export default it;
